import React from 'react';
import { useTranslation } from 'react-i18next';
import { IamProviderType } from '@1po/1po-bff-fe-spec/generated/backoffice/central_settings/model/CentralCountrySettings';
import { Select } from 'antd';
import { Row } from 'antd-v5';
import {
  DEFAULT_OTHER_BRAND_CATALOG,
  getOtherBrandCatalogByIamProvider,
  otherBrandCatalogData,
  OtherBrandCatalogType,
} from 'pages/BackOfficePage/BackOfficeCategories/CentralSettings/SelectOtherBrandCatalog/OtherBrandCatalogData';
import { SSelect } from 'pages/BackOfficePage/BackOfficeCategories/CentralSettings/SelectOtherBrandCatalog/SelectOtherBrandCatalog.styled';
import { SectionWrapper } from 'pages/SettingsPage/General/GeneralSettings.styled';
import { Flex, Text } from 'UI';

const { Option } = Select;

interface Props {
  selected: IamProviderType;
  onSelect: (iamProvider: IamProviderType) => void;
  enabled: boolean;
}

const SelectOtherBrandCatalog = ({ selected, onSelect, enabled }: Props) => {
  const { t } = useTranslation();
  const initialCatalog = getOtherBrandCatalogByIamProvider(selected) ?? DEFAULT_OTHER_BRAND_CATALOG;

  function findCatalog(catalogProviderType: string): OtherBrandCatalogType {
    return (
      otherBrandCatalogData.find((item) => item.iamProvider === catalogProviderType) ?? DEFAULT_OTHER_BRAND_CATALOG
    );
  }

  const handleSelectCatalog = (selectedCatalog: OtherBrandCatalogType) => {
    onSelect(selectedCatalog.iamProvider);
  };

  return (
    <SectionWrapper data-cy={'other-brand-catalog-selection'} $marginY={15}>
      <Flex direction={'column'} gap={15}>
        <Text type="heading4">
          {t('backoffice.central-settings.select.other-brand-catalog.title', 'Select other brand catalog')}
        </Text>
        <SSelect
          allowClear={false}
          showSearch={false}
          disabled={!enabled}
          placeholder={t('backoffice.central-settings.select.other-brand-catalog.title', 'Select other brand catalog')}
          value={initialCatalog.iamProvider}
          filterOption={(input, option) => option?.title.toLowerCase().indexOf(input.toLowerCase()) >= 0}
          optionFilterProp="label"
          onSelect={(catalogProviderType: string) => {
            handleSelectCatalog(findCatalog(catalogProviderType));
          }}
          showArrow
        >
          {otherBrandCatalogData.map(({ iamProvider, name }) => (
            <Option
              key={iamProvider}
              value={iamProvider}
              title={name}
              data-cy={`other-brand-catalog-dropdown-choice-${iamProvider}`}
            >
              <Row> &nbsp; {name} </Row>
            </Option>
          ))}
        </SSelect>
      </Flex>
    </SectionWrapper>
  );
};

export default SelectOtherBrandCatalog;
